:host {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
}

.scroll-overlay {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.scroll-overlay__viewport {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  box-sizing: border-box;
}

.scroll-overlay__viewport:focus-visible {
  outline: var(--dimension-stroke-width-025) solid var(--color-border-bold-brand);
  outline-offset: calc(-1 * var(--dimension-stroke-width-025));
}

.scroll-overlay__content {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding-block-end: var(--ds-scroll-overlay-block-size, 0);
  box-sizing: border-box;
}

.scroll-overlay__body {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  flex: 1 0 auto;
  min-height: 0;
}

.scroll-overlay__overlay {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: var(--dimension-z-index-floating);
}
